export const FORECAST_STEPS = [0, 15, 30, 45, 60];

export function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

export function flowAt(road, minute = 0) {
  const base = Number(road?.base ?? road?.flow ?? 0);
  const digits = String(road?.id ?? '').replace(/\D/g, '').slice(-4);
  const phase = ((Number.parseInt(digits, 10) || 17) % 31) / 31;
  const trend = Math.sin(phase * Math.PI * 2 + (minute / 60) * 1.7) * 0.07
    + (minute / 60) * 0.08;
  return Math.max(20, Math.round(base * (1 + trend)));
}

export function roadSeries(road) {
  const historicalMinutes = [-180, -150, -120, -90, -60, -30, 0];
  const historical = historicalMinutes.map((minute, index) => ({
    minute,
    label: minute === 0 ? 'ORA' : `${minute}m`,
    observed: Math.round(Number(road.base || 0) * (0.72 + 0.055 * index + 0.04 * Math.sin(index + Number(road.frc || 0)))),
    forecast: null,
  }));
  const current = historical[historical.length - 1].observed;
  historical[historical.length - 1].forecast = current;
  return historical.concat(FORECAST_STEPS.slice(1).map((minute) => ({
    minute,
    label: `+${minute}m`,
    observed: null,
    forecast: flowAt(road, minute),
  })));
}
